export const GET_WEBPAY_TOKEN = 'document/payment/GET_WEBPAY_TOKEN';
export const WEBPAY_TOKEN = 'document/payment/WEBPAY_TOKEN';

export const SAVE_WEBPAY_DATA = 'data/SAVE_WEBPAY_DATA';

export const SET_SPINNER = 'webpay/SET_SPINNER';
